import { authUrl } from "../resources";
import Axios from 'axios'

async function authenticate(credentials) {
    let response = await Axios.post(`${authUrl}`, credentials)
                                  .catch((err) => {console.log(err)});
    return response.data;
}

export default {
    name: 'authService',
    authenticate
} 